module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "dedi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('strong', [_vm._v("Dedicated To")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("First Responders who performed their duty and paid the highest price—Each of whom, trapped by circumstances, met his or her destiny;")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Surviving families adjusting to their new normality;")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("All who made it out;")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Those who kept me sane and balanced throughout the difficult years;")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And all of my absent friends and colleagues, especially Douglas G. Karpiloff & Sarah K. Ronningen.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("With Love and Gratitude")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-414d7c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_dedi.vue
// module id = 72
// module chunks = 0